import React, { useEffect, useRef, useState } from "react";
import Header from "../Sections/Partner/Header/Header";
import Banner from "../Sections/Partner/Banner/Banner";
import Choose from "../Sections/Partner/Zowo/Choose";
import BecomePartner from "../Sections/Partner/BecomePartner/BecomePartner";
import FAQ from "../Sections/Partner/FAQs/FAQ";
import Benefits from "../Sections/Partner/Benefits/Benefits";
import PartnerApp from "../Sections/Partner/PartnerApp/PartnerApp";
import FreeApp from "../Sections/Download/FreeApp";
import Footer from "../Footer/Footer";

const Partner = () => {
  return (
    <>
      <Header />
      <Banner></Banner>
      <Choose></Choose>
      <BecomePartner></BecomePartner>
      <Benefits></Benefits>
      <PartnerApp></PartnerApp>
      <FAQ></FAQ>
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default Partner;
